import React, { useEffect, useState } from "react";
import { List, ListItem, Paper, Typography } from "@mui/material";

import {
  BrowserRouter,
  Link,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import MenuListItem from "../components/listItems";
import Order from "../pages/Order";
import OrderInquiry from "../pages/OrderInquery";
import Settlement from "../pages/Settlement";
import AddressBook from "../pages/AddressBook";
import Env from "../pages/Env";
import Dashboard from "../pages/Dashboard";
import { makeStyles } from "@mui/styles";
import LogIn from "../pages/LogIn";

const menuWidth = 86;

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    backgroundColor: "#fafafa",
    width: 1500,
    height: 711,
    margin: "auto",
  },
  menu: {
    display: "flex",
    width: menuWidth,
    height: 685,
    marginTop: 27,
    background: "white",
  },
  logo: {},
  content: {
    marginTop: 56,
    marginLeft: 56,
  },
}));

function MenuList() {
  const classes = useStyles();

  return (
    <Paper elevation={0}>
      <nav className={classes.menu}>
        <List>
          <ListItem component={Link} to={"/dashboard"}>
            <img
              src={process.env.PUBLIC_URL + "/static/images/logo_v.svg"}
              width={"56"}
              height={"47"}
              alt={"카고콜"}
            />
          </ListItem>
          <MenuListItem />
        </List>
      </nav>
    </Paper>
  );
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      Cargocall
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function MainContainer() {
  const classes = useStyles();
  // RouteChange();
  const location = useLocation();

  useEffect(() => {
    console.log("pathName::", location.pathname);
    window.gtag("event", `pathChange-${document.title}`, {
      user_id: localStorage.getItem("customerName") || "none",
    });
  }, [location.pathname]);

  return (
    <div className={classes.root}>
      <MenuList />
      <main className={classes.content}>
        <Outlet />
      </main>
    </div>
  );
}

export default function Main() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/app" element={<MainContainer />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path={`freight/order`} element={<Order />} />
          <Route path={`freight/inquiry`} element={<OrderInquiry />} />
          <Route path={`settlement`} element={<Settlement />} />
          <Route path={`address_book`} element={<AddressBook />} />
          <Route path={`env`} element={<Env />} />
          <Route index element={<Navigate to="/app/dashboard" />} />
        </Route>
        <Route path={`/app/login`} element={<LogIn />} />
        <Route path={"*"} element={<Navigate to="/app/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}
